import { getRedirectProps } from "../../../WSUtils/urlUtils";
import { CustomMenuItem, isPathSelected } from "../NavMenu/getItem";

export const profileItems: CustomMenuItem[] = [
  {
    path: "/profile",
    label: "Min profil",
    icon: "pi pi-fw pi-user",

    isSelected: () =>
      isPathSelected(/^\/?$/) || isPathSelected(/^\/?profile$/i),
  },
  {
    path: "/workschedule",
    label: "Arbeidsplan",
    icon: "pi pi-fw pi-user-edit",

    isSelected: () => isPathSelected(/^\/?workschedule$/i),
  },
  {
    path: "/references",
    label: "Referanser",
    icon: "pi pi-fw pi-star",

    isSelected: () => isPathSelected(/^\/?references$/i),
  },
  {
    path: "/privacy",
    label: "Personvern",
    icon: "pi pi-fw pi-exclamation-triangle",

    isSelected: () => isPathSelected(/^\/?privacy$/i),
  },
  {
    path: "/frontpage",
    label: "Logg ut",
    icon: "pi pi-fw pi-sign-out",
    className: "log-out",

    isSelected: () => isPathSelected(/^\/?frontpage$/i),
    onClick: (evt, userInfo, item) => {
      const { onClick } = getRedirectProps("/auth/logout", {
        userInfo,
        mergeQs: {},
      });

      onClick(evt);
    },
  },
];
